export { ViewGrid as default } from './ViewGrid';
